//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Diagramming.js";
import "../no/Builder.js";
import "../Diagramming/Diagramming.PortBuilderList.js";
import "../no/ObjectList.js";
let d=[[[0,"Label",0,"Diagramming.CannedAnnotationBuilder",0],[0,"Node",0,"Diagramming.NodeBuilder",0],[0,"OwningSheet",0,"Diagramming.Sheet",0],[1,"Ports",0,"Diagramming.PortBuilderList",0],[0,"SymbolId",0,0]],[[["owningSheet","sybmolId"],"Initialize",{},2,0],[["symbolId"],"AddPort",{R_:{port:"Diagramming.PortBuilder"}},1,0]],[]];
SPLM.Diagramming.EquipmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Diagramming.EquipmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;